export const SAVED_PORTFOLIOS = 'Saved Portfolios';
export const MODEL_PORTFOLIOS = 'Model Portfolios';
